import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { advertisement, ServiceService } from '../service.service';
import { Platform } from '@ionic/angular';
import { OneSignal } from '@ionic-native/onesignal/ngx';

@Component({
  selector: 'app-course-detail',
  templateUrl: './course-detail.page.html',
  styleUrls: ['./course-detail.page.scss','../../assets/scss/styles.scss'],
})
export class CourseDetailPage implements OnInit {
  public course: any;
  public idCourse:number;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(public alertController: AlertController, 
    public services: ServiceService, 
    private activatedRoute: ActivatedRoute,
    private oneSignal: OneSignal, 
    private platform: Platform) { }

  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    this.idCourse = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    console.log(''+this.idCourse);
    (await this.services.getDetailCourse(this.idCourse)).subscribe(
      data => {
        this.course = data;
      },
        error => {
        console.log(error);
      }
    );
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(6);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  public gotoCourse(){
    window.open(this.course?.url, '_system', 'location=yes');
  }

  doInscription(){
    this.services.inscription(this.idCourse).subscribe(
      async (data:any) => {
        if(data?.string1){
          this.showAlert(data.string1);
          setTimeout(()=>{ 
            //window.open(this.course?.url, '_system', 'location=yes')
            this.openFrame(this.course?.url);
          },3000);
        }else{
          //window.open(this.course?.url, '_system', 'location=yes');
          this.openFrame(this.course?.url);
        }
      },
      async error => {
        console.log(error);
      },
    );
  }

  public openFrame(url : any ){

    if (this.platform.is('ios')) {
      var ifrm = document.createElement('iframe');
      ifrm.setAttribute('id', 'ifrm'); // assign an id
  
      // to place before another page element
      var el = document.getElementById('iframeHolder');
      el.parentNode.insertBefore(ifrm, el);
  
      // assign url
      ifrm.setAttribute('src', url);
      ifrm.setAttribute('width', '0px');
      ifrm.setAttribute('height', '0px');
    } else {
      window.open(url, '_system', 'location=yes')
    }


  }

  async showAlert(message:string){
    const alert = await this.alertController.create({
      message: message
    });
    await alert.present();
  }

  public showElement(dataElement : any ) {
    let show = false;
    if(dataElement) show = true;
    return show;
  }

  public isNumber(text:string){
    if(text){
      return !!text.match(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/);
    }
    return false;
  }

}
